import React, {useState} from 'react';
import {useTranslation} from "react-i18next";

interface SearchInputProps {
    onSearch: (type: string, query: string) => void;
}

export const SearchSelectInput: React.FC<SearchInputProps> = ({onSearch}) => {
    const { t } = useTranslation();
    const [placeholder, setPlaceholder] = useState(t('buscar_por'));
    const [type, setType] = useState('');
    const [query, setQuery] = useState('');

    const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedOptionText = e.target.options[e.target.selectedIndex].text;
        const value = e.target.options[e.target.selectedIndex].value;
        setPlaceholder(`${t('buscar_por')} ${selectedOptionText}`);
        setType(value)
    };


    return (
        <div className="search-input-container">
            <img style={{
                height: 5,
                width: 10,
                position: 'absolute',
                left: 10,
                alignSelf: 'center',
                bottom: 10,
                cursor: 'pointer'
            }} src={require('../assets/select.png')}/>

            <select onChange={handleSelectChange} style={{
                position: 'absolute',
                cursor: 'pointer',
                opacity: 0,
            }}>
                <option value="codi">{t('select_codigo_estacion')}</option>
                <option value="nom">{t('select_nombre_estacion')}</option>
                <option value="cp">{t('select_codigo_postal')}</option>
                <option value="ciutat">{t('select_poblacion')}</option>
                <option value="direccio">{t('select_direccion')}</option>
                <option value="provincia">{t('select_provincia')}</option>
            </select>
            <input
                style={{paddingLeft: 35}}
                value={query}
                onChange={e => setQuery(e.target.value)}
                className="search-input"
                placeholder={placeholder}
            />
            <img onClick={()=>{ onSearch(type,query)}} style={{height: 17, width: 17, position: 'absolute', right: 10, alignSelf: 'center', bottom: 5, cursor:'pointer'}}
                 src={require('../assets/searchIcon.png')}/>
        </div>
    );
}

export default SearchSelectInput;
